import Grid from "@mui/material/Grid2";
import { FormGroup, Table } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { DataFormat } from "utils";
import { useFrontendTable } from "components/table";
import { ContentProps } from "@cofano/cck/Table/Table";
import { CalculationMethod } from "view/calculationmethods/types/calculationmethod";
import { Fragment, ReactNode } from "react";
import type { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";


type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const PercentageOnAgreementsCalculationMethodDetails = ({ calculationMethod, hiddenFields }: CalculationMethodDetailsByTypeProps) => {
	const PercentageOnAgreementsCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.percentage",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "PERCENTAGE" })} overflow="hidden">
						{calculationMethod.percentage && DataFormat.percentage(calculationMethod.percentage, 2)}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.applicableAgreementTypes",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "AGREEMENT_TYPES" })} overflow="hidden">
						{calculationMethod.applicableAgreementTypes && calculationMethod.applicableAgreementTypes.map(x => intl.formatMessage({ id: `AGREEMENT_TYPE_${x}` })).join(", ")}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.applicableAgreements",
			render: () => (
				<ApplicableAgreements calculationMethod={calculationMethod} />
			),
		},
	];

	return (
		<>
			{PercentageOnAgreementsCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

const ApplicableAgreements = ({ calculationMethod }: { calculationMethod: CalculationMethod }) => {
	const { tableProps } = useFrontendTable({
		id: "applicableAgreements",
		content: calculationMethod.applicableAgreements as ContentProps,
		saveForOrganizationEnabled: false,
	});

	return (
		<Table
			{...tableProps}
			disableFooter
			columns={[ {
				id: "type",
				title: intl.formatMessage({ id: "AGREEMENT" }),
				render: row => intl.formatMessage({ id: `AGREEMENT_TYPE_${row.type}` }),
				width: 150,
				disableFlexGrow: true,
			},
			{
				id: "summary",
				title: intl.formatMessage({ id: "SUMMARY" }),
				render: row => row.calculationMethod.summary,
			} ]}
		/>
	);
};

export default PercentageOnAgreementsCalculationMethodDetails;
